import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getCropsForProductByTypeAndTrialsCountry } from 'api/CropNutritionPrograms';
import { getDetailTrialResults, getTrialResults, getTrialResultsFlyers } from 'api/TrialResults';
import { fetchWithLanguage } from 'store/helpers';

export const fetchTrialResults = fetchWithLanguage('fetchTrialResults', getTrialResults);
export const fetchTrialResultsFlyers = fetchWithLanguage('fetchTrialResultsFlyers', getTrialResultsFlyers);
export const fetchTrialResultsForProductForCurrentCountry = fetchWithLanguage(
    'fetchTrialResultsForProductForCurrentCountry',
    getCropsForProductByTypeAndTrialsCountry,
);
export const fetchTrialResultsForProductForOthers = fetchWithLanguage(
    'fetchTrialResultsForProductForOthers',
    getCropsForProductByTypeAndTrialsCountry,
);
export const fetchTrialResultsPageList = fetchWithLanguage(
    'fetchTrialResultsPageList',
    getCropsForProductByTypeAndTrialsCountry,
);
export const fetchDetailTrialResults = fetchWithLanguage('fetchDetailTrialResults', getDetailTrialResults);

const trialResultsSlice = createSlice({
    name: 'trialResultsSlice',
    initialState: {
        trialResults: {},
        trialResultsDetails: {},
        trialResultsFlyers: {},
        trialResultsPageList: {},
        trialResultsForProductForCurrentCountry: {
            data: [],
            next: false,
        },
        trialResultsForProductForOthers: {
            data: [],
            next: false,
        },
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchTrialResults.fulfilled, (state, action) => {
                state.trialResults = action.payload;
            })
            .addCase(fetchDetailTrialResults.fulfilled, (state, action) => {
                state.trialResultsDetails = action.payload;
            })
            .addCase(fetchTrialResultsPageList.fulfilled, (state, action) => {
                state.trialResultsPageList = action.payload;
            })
            .addCase(fetchTrialResultsFlyers.fulfilled, (state, action) => {
                state.trialResultsFlyers = action.payload;
            })
            .addCase(fetchTrialResultsForProductForCurrentCountry.fulfilled, (state, action) => {
                const { payload, meta } = action;
                state.trialResultsForProductForCurrentCountry.next = payload.next;

                if (meta.arg.page === 1) {
                    state.trialResultsForProductForCurrentCountry.data = payload.data;
                } else {
                    state.trialResultsForProductForCurrentCountry.data.push(...payload.data);
                }
            })
            .addCase(fetchTrialResultsForProductForOthers.fulfilled, (state, action) => {
                const { payload, meta } = action;
                state.trialResultsForProductForOthers.next = payload.next;

                if (meta.arg.page === 1) {
                    state.trialResultsForProductForOthers.data = payload.data;
                } else {
                    state.trialResultsForProductForOthers.data.push(...payload.data);
                }
            });
    },
});

export const selectTrialResultsPage = createSelector(
    [state => state.trialResultsState.trialResults],
    trialResults => trialResults.data || {},
);
export const selectTrialResultsFlyers = createSelector(
    [state => state.trialResultsState.trialResultsFlyers],
    trialResultsFlyers => trialResultsFlyers.data || {},
);
export const selectTrialResultsForProductForCurrentCountry = createSelector(
    [state => state.trialResultsState.trialResultsForProductForCurrentCountry],
    trialResultsForProductForCurrentCountry => trialResultsForProductForCurrentCountry || {},
);
export const selectTrialResultsForProductForOthers = createSelector(
    [state => state.trialResultsState.trialResultsForProductForOthers],
    trialResultsForProductForOthers => trialResultsForProductForOthers || {},
);
export const selectTrialResultsPageList = createSelector(
    [state => state.trialResultsState.trialResultsPageList],
    trialResultsPageList => trialResultsPageList.data || [],
);
export const selectDetailTrialResults = createSelector(
    [state => state.trialResultsState.trialResultsDetails],
    trialResultsDetails => trialResultsDetails.data || {},
);

export default trialResultsSlice.reducer;
